import { rootApi } from "../../api/rootApi";

export const panelActivityApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getPanelLoginActivity: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/panel-login-activity?limit=${params.limit || 50}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.slug,
        },
      }),
    }),
  }),
});

export const { useGetPanelLoginActivityMutation } = panelActivityApi;
